import axios from 'axios';

axios.defaults.withCredentials = true;

export async function saveUserData(formData) {
  try {
    const response = await axios.post(`${import.meta.env.VITE_APP_API_URL}save-user-data`, { formData });
    return response

  } catch (error) {
    console.error('Error al guardar los datos del usuario', error);
  }
}